var t=(r,l,n={})=>l===1?r:n.plural||`${r}s`;export{t as a};
